import { Injectable } from '@angular/core';
import { Observable, throwError, of, Subject, BehaviorSubject } from 'rxjs';
import { retry, catchError, map, finalize, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { Subdivision } from '../subdivisions/subdivision';

import { environment } from '../../environments/environment';
export interface Item {
  id: number;
  work_desc: string;
}

@Injectable({
  providedIn: 'root',
})

export class AdditionalworkService {

  private baseURL = environment.baseUrl;

  constructor(private http: HttpClient) {}

  saveAdditionalWork(locid: number, jobid: number, data: { item_id: number, item: string; note: string; who:string; time:Date;}[], updateRow:boolean = false, customer_id: number, region: string): Observable<any> {
      return this.http.post<any>(this.baseURL + '/rhAPI/jobEntry/additionalwork/'+ locid + '/' + jobid + '/' + updateRow, { data: data, customer_id: customer_id, region: region}, {observe: 'body'});
  }

  getAdditionalWork(locid: number, jobid: number): Observable<any> {
    return this.http.get<any>(this.baseURL + '/rhAPI/jobEntry/additionalwork/'+ locid + '/' + jobid, {observe: 'body'});
  }

  getDropdownItems(): Observable<Item[]> {
    return this.http.get<Item[]>(this.baseURL + '/rhAPI/jobEntry/additionalworkDropdownOptions');
  }
}
